import { Skeleton, Typography } from "antd";

const { Text } = Typography;

function LoyaltyDetailSummary({ loading = false, title, meta, action, className = "" }) {
  return (
    <div className={["loyalty-detail-summary", className].filter(Boolean).join(" ")}>
      {loading ? (
        <Skeleton active paragraph={{ rows: 2 }} />
      ) : (
        <div className="loyalty-detail-summary-content">
          <div className="loyalty-detail-summary-info">
            <Text strong className="loyalty-detail-name">
              {title ?? "—"}
            </Text>
            {meta}
          </div>
          {action}
        </div>
      )}
    </div>
  );
}

export default LoyaltyDetailSummary;
